import React, {useState} from 'react';
import {calculate, formatArea} from '../lib/calculations';

export default function FormulaExplorer() {
  const [height, setHeight] = useState(170);
  const [weight, setWeight] = useState(70);
  const results = calculate(height, weight);
  const product = height * weight;
  const quotient = product / 3600;
  const comparison = ['Mosteller', 'DuBois e DuBois', 'Haycock'];

  return (
    <section className="panel" id="explorador">
      <div className="section-heading">
        <h2>Como a fórmula muda com as medidas?</h2>
        <p>Arraste os controles para comparar três estimativas e acompanhar a conta de Mosteller.</p>
      </div>
      <div className="slider-grid">
        <label>Altura <strong>{height.toLocaleString('pt-BR')} cm</strong><input type="range" min="30" max="250" value={height} onChange={event => setHeight(Number(event.target.value))} /></label>
        <label>Peso <strong>{weight.toLocaleString('pt-BR')} kg</strong><input type="range" min="1" max="400" value={weight} onChange={event => setWeight(Number(event.target.value))} /></label>
      </div>
      <div className="steps" aria-live="polite">
        <div><span>Multiplique</span><strong>{product.toLocaleString('pt-BR')} × {weight.toLocaleString('pt-BR')} = {(height * weight).toLocaleString('pt-BR')}</strong></div>
        <div><span>Divida por 3600</span><strong>{(height * weight).toLocaleString('pt-BR')} ÷ 3600 = {quotient.toLocaleString('pt-BR', {maximumFractionDigits: 3})}</strong></div>
        <div><span>Extraia a raiz</span><strong>√{quotient.toLocaleString('pt-BR', {maximumFractionDigits: 3})} = {formatArea(results.Mosteller)} m²</strong></div>
      </div>
      <div className="bars" role="img" aria-label={`Gráfico comparativo: ${comparison.map(name => `${name} ${formatArea(results[name])}`).join(', ')} metros quadrados`}>
        {comparison.map(name => (
          <div className="bar-row" key={name}>
            <span>{name}</span>
            <div className="bar-track"><div className="bar-fill" style={{width: `${Math.min(100, results[name] / 4 * 100)}%`}} /></div>
            <strong>{formatArea(results[name])} m²</strong>
          </div>
        ))}
      </div>
    </section>
  );
}
